import { render, staticRenderFns } from "./essay_status_badge.vue?vue&type=template&id=11a3cfb8&scoped=true&"
import script from "./essay_status_badge.vue?vue&type=script&lang=js&"
export * from "./essay_status_badge.vue?vue&type=script&lang=js&"
import style0 from "./essay_status_badge.vue?vue&type=style&index=0&id=11a3cfb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a3cfb8",
  null
  
)

export default component.exports